//IMPORTAÇÕES
import React, { useState, useEffect } from 'react';/*eslint-disable*/
import {formatarData} from '../../../utils/formatadorDataTabela'/*eslint-disable*/
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'/*eslint-disable*/
import { useDispatch, useSelector, connect } from 'react-redux';
import {api} from '../../../conexoes/api';
import BootstrapTable from 'react-bootstrap-table-next';
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator';
//COMPONENTES
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import EnviarSms from './enviarSms/enviarSms'
import ConversasSms from './conversas/conversas'
import BarraFiltragem from '../../componentesModais/barraFiltragem/barraFiltragem'
import BarraDadosCliente from '../../componentesModais/barraDadosCliente/barraDadosCliente'
import RelatorioEnvioSms from './relatorioEnvioSms/RelatorioEnvioSms'
//ESTILIZAÇÃO
import '../../../css/painelSms/smsMensagens/tabela.css'
// SPINNER
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
// COLETA CLICKSTREAM
import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'

//REDUX
import { limpadorFiltros, mudarManejador, limpouBusca, realizouBusca, desabilitarAcoes, desabilitarAcoesCliente, revelarAtualizarSms as revelarAtualizarSmsDespacho, mudarFiltros, revelarBarraFiltragem, realizouFiltro  } from "../../../redux/actions/index"
import utilsSms from '../../../utils/sms';

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let itensVar = []


function Grid(props){
    //HOOKS TABELA
    const [itens, setItens] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [renderizar, setRenderizar] = useState(false);
    const [valorLimite, setValorLimite] = useState(50); // eslint-disable-next-line
    const [envioSelecionado, setEnvioSelecionado] = useState([])
    const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
    const [cdSmsContaUsuario, setCdSmsContaUsuario] = useState(undefined);
    const [saldoReal, setSaldoReal] = useState(0);
    let conteudoBusca = useSelector(state => state.manejadorState.conteudoBusca);
    let limpouBuscaGeral = useSelector(state => state.manejadorState.limpouBusca);
    let realizouBuscaGeral = useSelector(state => state.manejadorState.realizouBusca);
    // SPINNER
    const [spinAtivo, setSpinAtivo] = useState(false);


    //REDUX VARIÁVEIS
    const despacho = useDispatch();
    let filtros = useSelector(state => state.filtrosState.filtros);

    let revelarAtualizarSms =  useSelector(state => state.smsState.revelarAtualizarSms);
    let revelarEnviarSmsModulo =  useSelector(state => state.smsState.revelarEnviarSmsModulo);
    let revelarVerConversasSms = useSelector(state => state.smsState.revelarVerConversasSms);
    let revelarRelatorioEnvioSms = useSelector(state => state.smsState.revelarRelatorioEnvioSms);
    let revelarBarraFiltro = useSelector(state => state.filtrosState.revelarBarraFiltragem);
    let realizouFiltragem = useSelector(state => state.manejadorState.realizouFiltro);
    let visualizarDados =  useSelector(state => state.virtueyesState.visualizarDados);
    // USABILIDADE
    const [coletaUsabilidade, setColetaUsabilidade] = useState(true)
    let temFiltros = false;

    useEffect(() => {
        if(coletaUsabilidade) {
            ColetaClickstream(465) // 'smsMensagensTabela'
            setColetaUsabilidade(false)
        }
    },[])

    async function carregarSaldo(){
        if (cdSmsContaUsuario !== undefined && cdSmsContaUsuario !== false && cdSmsContaUsuario !== '') 
        {
            const query = utilsSms.getNewQueryGet("paginaAtual=0&carregarLimit=1")
            await api.get('/m1/consultar/smsExtrato?'+query)
                .then(function (response) {
                    if (response.data.status == 200 && response.data.dados[0] != undefined){
                        setSaldoReal(response.data.dados[0].n0_saldo_real)
                    } else {
                        setSaldoReal(0);
                    }
                })
        }
    }

    useEffect(() => {
        function checarFiltros() {
            if (filtros.vazio === 'vazio') {
                temFiltros = false;
            } else {
                temFiltros = true;
            }
        }
        checarFiltros();
    }, [filtros]);

    useEffect(()=>{
        if(props.filtros.vazio){
            despacho(revelarBarraFiltragem(false))
            if(!filtros.vazio){
                despacho(mudarFiltros({vazio: 'vazio'}))
            }
            despacho(limpadorFiltros(true))
        }
    }, [])

    useEffect(() =>{
        async function  atualizarEnviosRespostas(){
            if(revelarAtualizarSms === true){
                setSpinAtivo(true)
                await api.post('/m1/consultar/sincronizacaoSmsStatus',{'cd_sms_conta_usuario':utilsSms.getCdSmsContaUsuario('cd_sms_conta_usuario')})
                await api.post('/m1/consultar/sincronizacaoSmsResposta')
                handleMensagemSucesso()
                despacho(revelarAtualizarSmsDespacho(false))
            }
        }
        atualizarEnviosRespostas()
    }, [revelarAtualizarSms])

    useEffect(() => {
        setSpinAtivo(true)

        //despacho redux
        despacho(mudarManejador("envioSms"));
        despacho(desabilitarAcoes(true));
        despacho(desabilitarAcoesCliente(true));
        async function carregarTabela(){
            setCdSmsContaUsuario(utilsSms.getCdSmsContaUsuario()) 
            //clicou no botão de limpar a busca geral e retorna tudo ao estado original
            if(limpouBuscaGeral){
                despacho(limpouBusca(false));
                restaurarConfigsIniciaisPagina()
            }

            //clicou no botão de busca geral
            if(realizouBuscaGeral){
                despacho(realizouBusca(false));
                restaurarConfigsIniciaisPagina()
            }    

            //clicou no botão para filtro
            if(realizouFiltragem){
                despacho(realizouFiltro(false));
                restaurarConfigsIniciaisPagina()
            }  

            if(conteudoBusca  && !temFiltros){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                    await contarItens();
                }
                else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    await contarItens();

                    const query = utilsSms.getNewQueryGet('paginaAtual='+contador+'&carregarLimit='+valorLimite+'&buscar='+conteudoBusca)
                    const { data } = await api.get('/m1/consultar/smsEnvio/tabela?'+query);
                    inserirData(data.dados)
                }
            }else if(temFiltros){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                    await contarItens();
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                const dados = utilsSms.getNewBodyPost({
                    paginaAtual: contador,
                    carregarLimit: valorLimite,
                    filtros: filtros
                })

                if (controladorPagina <= paginaAtual) {
                    const { data } = await api.post("/m1/filtrar/smsEnvio", dados); 
                    inserirData(data.dados)
                }
            }else{
                if(totalPaginas == 0){
                    await contarItens();
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    let query = utilsSms.getNewQueryGet('paginaAtual='+contador+'&carregarLimit='+valorLimite);

                    const { data } = await api.get('/m1/consultar/smsEnvio/tabela?'+query);
                    inserirData(data.dados)
                }
            }
            setSpinAtivo(false)
        }
        carregarTabela();
    }, [paginaAtual, conteudoBusca, renderizar, filtros])
    carregarSaldo();
  
    function inserirData(data){
        for(let i=0;i<totalItens;i++){
            if (contador === i){
                let k = i
                for(let j=0;j<data.length;j++){
                    itensVar[k] = data[j]
                    k++
                }
            }
            if(i == (totalItens-1)){
                setItens(JSON.parse(JSON.stringify(itensVar)))
            }
        }
    }

    async function contarItens(){
        let arrayItens = []
        let apiData = [];
        if (controladorPagina <= paginaAtual && props.filtros.vazio) { 
            const query = utilsSms.getNewQueryGet('contar=true&buscar='+conteudoBusca)
            apiData = await api.get('/m1/consultar/smsEnvio/tabela?'+query);
        }
        else{
            const dados = utilsSms.getNewBodyPost({
                paginaAtual: contador,
                carregarLimit: valorLimite,
                filtros: filtros,
                contar: true
            })
            apiData = await api.post("/m1/filtrar/smsEnvio", dados); 
        }
        totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
        totalItens = apiData.data.dados[0].CONTADOR;
        for( var i = 0 ; i < apiData.data.dados[0].CONTADOR; i++){
            arrayItens.push(i)
        }
        itensVar = arrayItens
    }

    function restaurarConfigsIniciaisPagina(){
        totalPaginas = 0
        contador = 0
        controladorPagina = 1
        totalItens = 0
        setPaginaAtual(1)
    }
     
    function handleMensagemSucesso(confirmacao){
        if(revelarMensagemSucesso === false){
            setRevelarMensagemSucesso(true)
        }else{
            setRevelarMensagemSucesso(false)
            setRenderizar(!renderizar)
            restaurarConfigsIniciaisPagina()
            if(confirmacao === true){
                //ALGUMA FUNÇÃO
            }
        }
    }


    const colunas = [{
            dataField: 'cd_sms_envio',
            text: 'ID',
            hidden:true,
            sort: true,
            headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
            headerStyle: (colum, colIndex) => {
                return { width: '130px'}
            },
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: "dt_created_at",
            headerClasses: 'nao-selecionavel',
            text: 'Data',
            sort: true,
            formatter: (cell, row) => {
                if(cell){
                    cell = cell.replace('T', ' ').split('.')
                    if(cell.length > 0){
                        cell = cell[0]
                    }
                }
                return formatarData(cell);
            }
        }
        ,
        {
            dataField: 'n0_msisdn',
            headerClasses: 'nao-selecionavel',
            text: 'Linha',
            sort: true,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        // {
        //     dataField: 'ds_sms_tipo',
        //     headerClasses: 'nao-selecionavel',
        //     text: 'Tipo',
        //     sort: true,
        //     formatter: (cell, row) => {
        //         return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        //     }
        // },
        {
            dataField: 'ds_sms_status',
            headerClasses: 'nao-selecionavel',
            text: 'Status',
            sort: true,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'ds_mensagem',
            headerClasses: 'nao-selecionavel',
            text: 'Mensagem',
            sort: true,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'qtd_respostas',
            headerClasses: 'nao-selecionavel',
            text: 'Resposta',
            sort: true,
            formatter: (cell, row) => {
                if(row.cd_sms_tipo == 2)
                  return <p className="fonte-cor-1 label-tabela-1">{cell > 0 ? 'Recebida': 'Não Recebida'}</p>;
                else
                  return <p className="fonte-cor-1 label-tabela-1">-</p>;
            }
        },
    ]
    
    const eventosLinhas = {
        onClick: (e, row, rowIndex) => {
            setEnvioSelecionado(row)            
        }
    }

    const opcoesPaginacao = {
        page: paginaAtual,
        showTotal: true,
        sizePerPage: valorLimite,
        firstPageTitle: 'Primeira',
        lastPageTitle: 'Última',
        nextPageTitle: 'Proxima',
        prePageTitle: 'Anterior',
        custom: true,
        onPageChange:(page) => {setPaginaAtual(page)}
    }

    const selecaoLinhas = {
        mode: 'radio',
        onSelect: (row, isSelect, rowIndex, e) => {
            if(isSelect){
               setEnvioSelecionado(row)
               despacho(desabilitarAcoes(false));
            }
        },
        selectionRenderer: ({ mode, ...rest }) => {
            return (
                <label className="label-checkbox-cliente-virtueyes fonte-cor-1">
                    <input type={mode} id=" CLIENTEVEYE" name="CLIENTE"/>
                    <span className="checkbox-cliente-virtueyes radio-button-cor-1"></span>
                </label>
            )
        }
    };


    return(
        <div className='container-tela'>
            {visualizarDados === true &&
                <BarraDadosCliente/>
            }
        { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            {revelarVerConversasSms === true &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal-tabela-conversas-sms-container">
                        <ConversasSms
                        setRenderizar={setRenderizar}
                        renderizar={renderizar}
                        cd_sms_conta_usuario={cdSmsContaUsuario}
                        msisdn={envioSelecionado.n0_msisdn}
                        >
                        </ConversasSms>
                    </div>
                </div>
            }
            { saldoReal !== 0 &&
                <div id='smsTabela'>
                    <span className='label-valor-cancelamento-reposicao-1 fonte-cor-1 negrito'>Créditos disponíveis: </span>
                    <span className="label-valor-cancelamento-reposicao-2 fonte-cor-2 negrito">{saldoReal}</span> 
                </div>
            }
            {revelarEnviarSmsModulo === true &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal-tabela-envio-sms-container">
                        <EnviarSms
                        setRenderizar={setRenderizar}
                        renderizar={renderizar}
                        >
                        </EnviarSms>
                    </div>
                </div>
            }

            {revelarRelatorioEnvioSms === true &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal-tabela-envio-sms-container">
                        <RelatorioEnvioSms
                        setRenderizar={setRenderizar}
                        renderizar={renderizar}
                        >
                        </RelatorioEnvioSms>
                    </div>
                </div>
            }
            
            { revelarMensagemSucesso &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemSucesso
                            handleMensagemSucesso={handleMensagemSucesso}
                            mensagemTitulo={"Sucesso"}
                            mensagemParagrafo1={"As Mensagens foram atualizadas."}
                            mensagemBotao={"OK"}
                        />
                    </div>
                </div>
            }
            { revelarBarraFiltro === true &&
                <BarraFiltragem/>
            }
            <PaginationProvider pagination={Paginador(opcoesPaginacao)} >
                {
                    ({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <>
                            <BootstrapTable
                                hover={true}
                                condensed={true}
                                keyField='cd_sms_envio' 
                                data={itens} 
                                columns={colunas} 
                                rowEvents={eventosLinhas}
                                bootstrap4={true}
                                bordered={false}
                                selectRow={ selecaoLinhas }
                                classes="tabela"
                                noDataIndication={!spinAtivo && "Nenhum item encontrado"}
                                { ...paginationTableProps }
                            />
                             <PaginacaoTabela
                                setPaginaAtual={setPaginaAtual}
                                totalPaginas={totalPaginas}
                                totalItens={totalItens}
                                valorLimite={valorLimite}
                                paginaAtual={paginaAtual}
                                page={paginationProps.page}
                                onPageChange={paginationProps.onPageChange}
                            />
                        </>
                    )
                }
            </PaginationProvider>
            <text className="itens-exibidos-tabela fonte-cor-1">
                Mostrando 
                <span className="label-tabela-itens-exibidos">{contador + 1}</span>
                    - 
                <span className="label-tabela-itens-exibidos">{ contador + valorLimite <= totalItens ? contador + valorLimite : totalItens }</span>
                    de 
                <span className="label-tabela-itens-exibidos">{totalItens}</span>
            </text>
           
        </div>
    )
}

function mapStateToProps(state) {
    return { conteudoBusca: state.manejadorState.conteudoBusca, filtros: state.filtrosState.filtros };
} 

//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(Grid));